import { render, staticRenderFns } from "./OpenVPNNodeForm.vue?vue&type=template&id=06cc07c1&scoped=true"
import script from "./OpenVPNNodeForm.vue?vue&type=script&lang=js"
export * from "./OpenVPNNodeForm.vue?vue&type=script&lang=js"
import style0 from "./OpenVPNNodeForm.vue?vue&type=style&index=0&id=06cc07c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc07c1",
  null
  
)

export default component.exports